export default {
    state: {
        locations: [],
    },
    mutations: {
        setLocations(state, locations) {
            state.locations = locations.sort((a, b) => { return a.full_name.localeCompare(b.full_name) })
        },
        addLocation(state, location) {
            state.locations.push(location)
            state.locations.sort((a, b) => { return a.full_name.localeCompare(b.full_name) })
        },
        updateLocation(state, location) {
            const index = state.locations.findIndex(item => item.id === location.id)
            Vue.set(state.locations, index, location)
            state.locations.sort((a, b) => { return a.full_name.localeCompare(b.full_name) })
        },
        removeLocation(state, manufacturerId) {
            state.locations = state.locations.filter(item => item.id !== manufacturerId)
        },
    },
    getters: {
        listLocations: state => state.locations,
        findLocation: state => id => state.locations.find(item => item.id === id)
    },
    actions: {
        loadLocations(context, cb) {
            window.axios.get('/api/locations')
                .then(({ data }) => {
                    context.commit('setLocations', data)
                    if (cb) {
                        cb();
                    }
                })
                .catch(error => console.error(error))
        },
        addLocation(context, payload) {
            context.commit('addLocation', payload)
        },
        updateLocation(context, payload) {
            context.commit('updateLocation', payload)
        },
        removeLocation(context, locationId) {
            context.commit('removeLocation', locationId)
        },
    }
}
